import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=2939eca4&scoped=true&"
import script from "./deviceDetails.vue?vue&type=script&lang=js&"
export * from "./deviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&id=2939eca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939eca4",
  null
  
)

export default component.exports